import { Heading, IconButton, icons } from "@/ui";

type CartHeaderProps = {
  /** Products in the order, not units. */
  cartCount: number;
  onClose: () => void;
};

const getSubtitle = (cartCount: number) => {
  if (cartCount === 0) {
    return "Your cart is empty";
  }

  return `Monthly subscription, ${cartCount} ${cartCount === 1 ? "product" : "products"}`;
};

export const CareplanCartHeader = ({ cartCount, onClose }: CartHeaderProps) => {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-line px-4 py-3.5 sm:px-6 sm:py-[18px]">
      <div className="flex gap-3.5">
        <div className="relative top-1.5 w-fit">
          <icons.CartIcon aria-hidden="true" />
          <div className="absolute -top-1 -right-1 flex size-4 items-center justify-center rounded-full bg-surface-inverted text-xs text-content-on-inverted">
            {cartCount}
          </div>
        </div>
        <div>
          <Heading className="text-[22px] leading-tight sm:text-[22px]" level={2}>
            Your Cart
          </Heading>
          <p className="text-base text-content-secondary">{getSubtitle(cartCount)}</p>
        </div>
      </div>
      <IconButton className="-mr-2 text-content-muted" label="Close cart" onClick={onClose}>
        <icons.XMarkIcon aria-hidden="true" className="size-7" />
      </IconButton>
    </div>
  );
};
